<div *ngIf="visible" class="eva-command-palette-container">
  <!-- Backdrop -->
  <div class="eva-command-palette__backdrop" (click)="onBackdropClick()"></div>

  <!-- Palette -->
  <div
    class="eva-command-palette"
    [ngStyle]="paletteStyle"
    (click)="onContentClick($event)"
    role="dialog"
    aria-modal="true"
    aria-label="Palette de commandes"
  >
    <!-- Search Header -->
    <div class="eva-command-palette__header">
      <div class="eva-command-palette__search">
        <ng-icon name="heroMagnifyingGlass" class="eva-command-palette__search-icon"></ng-icon>
        <input
          #searchInput
          type="text"
          class="eva-command-palette__input"
          [placeholder]="placeholder"
          [value]="searchValue"
          (input)="onSearchChange($any($event.target).value)"
          autocomplete="off"
          spellcheck="false"
        />
        <button
          *ngIf="searchValue"
          type="button"
          class="eva-command-palette__clear"
          (click)="clearSearch()"
          aria-label="Effacer la recherche"
        >
          <ng-icon name="heroXMark"></ng-icon>
        </button>
        <kbd class="eva-command-palette__kbd">esc</kbd>
      </div>
    </div>

    <!-- Content -->
    <div class="eva-command-palette__content">
      <!-- Skeleton Loading -->
      <ng-container *ngIf="loading">
        <div class="eva-command-palette__section">
          <div class="eva-command-palette__section-header">
            <div class="eva-command-palette__skeleton eva-command-palette__skeleton--section-label"></div>
          </div>
          <div class="eva-command-palette__items">
            <div *ngFor="let i of [1, 2, 3]" class="eva-command-palette__skeleton-item">
              <div class="eva-command-palette__skeleton eva-command-palette__skeleton--icon"></div>
              <div class="eva-command-palette__skeleton-item-content">
                <div
                  class="eva-command-palette__skeleton eva-command-palette__skeleton--label"
                  [style.width]="i === 1 ? '60%' : i === 2 ? '45%' : '55%'"
                ></div>
                <div
                  class="eva-command-palette__skeleton eva-command-palette__skeleton--desc"
                  [style.width]="i === 1 ? '40%' : i === 2 ? '50%' : '35%'"
                ></div>
              </div>
            </div>
          </div>
        </div>
        <div class="eva-command-palette__section">
          <div class="eva-command-palette__section-header">
            <div
              class="eva-command-palette__skeleton eva-command-palette__skeleton--section-label"
              style="width: 60px"
            ></div>
          </div>
          <div class="eva-command-palette__items">
            <div *ngFor="let i of [1, 2]" class="eva-command-palette__skeleton-item">
              <div class="eva-command-palette__skeleton eva-command-palette__skeleton--icon"></div>
              <div class="eva-command-palette__skeleton-item-content">
                <div
                  class="eva-command-palette__skeleton eva-command-palette__skeleton--label"
                  [style.width]="i === 1 ? '50%' : '70%'"
                ></div>
              </div>
            </div>
          </div>
        </div>
      </ng-container>

      <!-- Results -->
      <ng-container *ngIf="!loading && hasResults">
        <div *ngFor="let section of filteredSections; trackBy: trackBySection" class="eva-command-palette__section">
          <!-- Section Header -->
          <div
            class="eva-command-palette__section-header"
            [class.eva-command-palette__section-header--recents]="section.id === '__recents__'"
          >
            @if (section.icon && showIcons) {
              @if (isNgIconName(section.icon)) {
                <ng-icon [name]="section.icon" />
              } @else {
                <i [class]="section.icon"></i>
              }
            }
            <span>{{ section.label }}</span>
          </div>

          <!-- Section Items -->
          <div class="eva-command-palette__items">
            <button
              *ngFor="let item of section.items; trackBy: trackByItem"
              type="button"
              class="eva-command-palette__item"
              [class.eva-command-palette__item--selected]="isItemSelected(item)"
              [class.eva-command-palette__item--disabled]="item.disabled"
              [class.eva-command-palette__item--recent]="isRecentItem(item)"
              [disabled]="item.disabled"
              (click)="selectItem(item)"
              (mouseenter)="onItemMouseEnter(item)"
            >
              <!-- Icon -->
              @if (item.icon && showIcons) {
                @if (isNgIconName(item.icon)) {
                  <ng-icon class="eva-command-palette__item-icon" [name]="item.icon" />
                } @else {
                  <i class="eva-command-palette__item-icon" [class]="item.icon"></i>
                }
              }

              <!-- Label & Description -->
              <div class="eva-command-palette__item-content">
                <span class="eva-command-palette__item-label">{{ item.label }}</span>
                <span *ngIf="item.description" class="eva-command-palette__item-desc">
                  {{ item.description }}
                </span>
              </div>

              <!-- Shortcut -->
              <kbd *ngIf="item.shortcut && showShortcuts" class="eva-command-palette__item-shortcut">
                {{ item.shortcut }}
              </kbd>
            </button>
          </div>
        </div>
      </ng-container>

      <!-- Empty State -->
      <div *ngIf="!loading && !hasResults" class="eva-command-palette__empty">
        <ng-icon name="heroMagnifyingGlass" class="eva-command-palette__empty-icon"></ng-icon>
        <p class="eva-command-palette__empty-text">{{ emptyMessage }}</p>
        <p *ngIf="searchValue" class="eva-command-palette__empty-hint">Essayez avec d'autres mots-clés</p>
      </div>
    </div>

    <!-- Footer -->
    <div class="eva-command-palette__footer">
      <div class="eva-command-palette__footer-hint"><kbd>↑↓</kbd> naviguer</div>
      <div class="eva-command-palette__footer-hint"><kbd>↵</kbd> sélectionner</div>
      <div class="eva-command-palette__footer-hint"><kbd>esc</kbd> fermer</div>
    </div>
  </div>
</div>
